import UIModel from './UIModel';

class DirectionUIModel extends UIModel {
  constructor(directionText = '') {
    super();
    this.directionText = directionText;
  }
}

export default DirectionUIModel;
